/**
 * Created by pbo on 19/05/16.
 */
angular.module('taric.duty.calculate.units', ['taric.model.cd', 'common.filter.description', 'common.filter.decimalNumber', 'common.helper'])
    .controller('CalculateDutyUnitsCtrl', function ($translatePartialLoader, CalculateDutyModel, $filter, $translate, CommonHelper, CONSTANTS) {
        $translatePartialLoader.addPart('taric/duties/calculate');
        var unitsCtrl = this;

        unitsCtrl.init = function () {
            // Validated data used for calculation input
            unitsCtrl.inputData = CalculateDutyModel.getCalculationInput();

            // Backing data model for view
            unitsCtrl.model = CalculateDutyModel;

            unitsCtrl.resetError();

            if (unitsCtrl.inputData.measurementUnits !== null) {
                // Back from another tab. Set values.
                for (let i = 0; i < unitsCtrl.inputData.measurementUnits.length; i++) {
                    unitsCtrl.model.measurementUnits[i].value = unitsCtrl.inputData.measurementUnits[i].value;
                }
            }
        };

        unitsCtrl.resetError = function () {
            unitsCtrl.errorCode = null;
            unitsCtrl.errorParams = null;
            unitsCtrl.errorType = null;
        };

        unitsCtrl.validateMeasurementUnitValue = function (measurementUnit) {
            unitsCtrl.resetError();

            if (measurementUnit.value === null || measurementUnit.value === '' || measurementUnit.value === undefined) {
                unitsCtrl.errorCode = 'i8n.qry.cd.faultcode.170';
                return false;
            }

            if (!CommonHelper.isDecimalNumber(measurementUnit.value)) {
                unitsCtrl.errorCode = 'i8n.jsfconv.decnum.notnum';
                return false;
            }

            var measurementUnitValue = CommonHelper.getDecimalNumber(measurementUnit.value);

            // Measurement Unit: n..16,6
            // Valid pattern = "^(-)?\d{0,10}(\,|\.\d{0,6})?$"
            // Because JavaScript Numbers can only handle accurate up to 15 digits, max value is reduced 1 decimal digit
            if (measurementUnitValue > 9999999999.99999) {
                unitsCtrl.errorCode = 'i8n.jsfconv.decnum.toobig';
                return false;
            }

            if (measurementUnitValue < -9999999999.99999) {
                unitsCtrl.errorCode = 'i8n.jsfconv.decnum.toosmall';
                return false;
            }

            measurementUnitValue = CommonHelper.truncateDecimalNumber(measurementUnitValue, 6);
            measurementUnit.value = CommonHelper.formatDecimalNumber(measurementUnitValue, CommonHelper.getNumberFraction(measurementUnitValue), '', CONSTANTS.decimalSeparator);

            return true;
        };

        unitsCtrl.validateMeasurementUnits = function () {
            var valid = true;
            var errorCode = null;
            if (unitsCtrl.model.measurementUnits.length > 0) {
                for (let i = 0; i < unitsCtrl.model.measurementUnits.length; i++) {
                    if (!unitsCtrl.validateMeasurementUnitValue(unitsCtrl.model.measurementUnits[i])) {
                        valid = false;
                        // Save errorCode if not set.
                        if (errorCode === null && unitsCtrl.errorCode !== null) {
                            errorCode = unitsCtrl.errorCode;
                        }
                    }
                }
            }
            if (!valid) {
                unitsCtrl.errorCode = errorCode;
            }
            return valid;
        };

        unitsCtrl.next = function () {
            var valid = unitsCtrl.validateForm();
            if (valid) {
                unitsCtrl.navigatingToNextTab = true;
                unitsCtrl.model.goToNextTab('units').then(function () {
                    unitsCtrl.navigatingToNextTab = false;
                }, function (error) {
                    unitsCtrl.errorCode = error.data.code;
                    unitsCtrl.errorParams = error.data.params;
                    unitsCtrl.errorType = error.data.errorType;
                    unitsCtrl.navigatingToNextTab = false;
                });
            }
            return valid;
        };

        unitsCtrl.validateForm = function () {
            unitsCtrl.resetError();
            var valid = true;

            if (!unitsCtrl.validateMeasurementUnits()) {
                valid = false;
            } else {
                if (unitsCtrl.model.measurementUnits.length > 0) {
                    // Create input data
                    unitsCtrl.inputData.measurementUnits = [];
                    for (let i = 0; i < unitsCtrl.model.measurementUnits.length; i++) {
                        unitsCtrl.inputData.measurementUnits[i] = {
                            id: unitsCtrl.model.measurementUnits[i].id,
                            value: unitsCtrl.model.measurementUnits[i].value
                        };
                    }
                }
            }
            return valid;
        };
    });



// WEBPACK FOOTER //
// ./app/taric/duties/calculate/units/cd.units.js